import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { setSchedule } from "../../../modules/form";
import ModalUI from "./ModalUI";
import classes from "./WorkHours.module.css";
import buttonImg from "./assets/Fill.png";

const timeTable = [
  { title: "00", text: "오전 12시" },
  { title: "01", text: "오전 1시" },
  { title: "02", text: "오전 2시" },
  { title: "03", text: "오전 3시" },
  { title: "04", text: "오전 4시" },
  { title: "05", text: "오전 5시" },
  { title: "06", text: "오전 6시" },
  { title: "07", text: "오전 7시" },
  { title: "08", text: "오전 8시" },
  { title: "09", text: "오전 9시" },
  { title: "10", text: "오전 10시" },
  { title: "11", text: "오전 11시" },
  { title: "12", text: "오후 12시" },
  { title: "13", text: "오후 1시" },
  { title: "14", text: "오후 2시" },
  { title: "15", text: "오후 3시" },
  { title: "16", text: "오후 4시" },
  { title: "17", text: "오후 5시" },
  { title: "18", text: "오후 6시" },
  { title: "19", text: "오후 7시" },
  { title: "20", text: "오후 8시" },
  { title: "21", text: "오후 9시" },
  { title: "22", text: "오후 10시" },
  { title: "23", text: "오후 11시" },
];

const hourTable = [
  { title: 3, text: "3시간" },
  { title: 4, text: "4시간" },
  { title: 5, text: "5시간" },
  { title: 6, text: "6시간" },
  { title: 7, text: "7시간" },
  { title: 8, text: "8시간" },
  { title: 9, text: "9시간" },
  { title: 10, text: "10시간" },
  { title: 11, text: "11시간" },
  { title: 12, text: "12시간" },
];

const WorkHours = () => {
  const [modal, setModal] = useState(false);
  const [timeName, setTimeName] = useState("선택");
  const [hourName, setHourName] = useState("선택");
  const [toggle, setToggle] = useState();
  const { workType, startDate } = useSelector((state) => ({
    workType: state.form.workType,

    startDate: state.form.schedule.startDate,
  }));
  const dispatch = useDispatch();

  const modalHandler = (event) => {
    setToggle(event.target.value);
    setModal(true);
  };

  const onConfirm = () => {
    setModal(false);
  };

  const timeHandler = (event) => {
    let timeText = event.target.innerText;
    setTimeName(timeText);
    dispatch(setSchedule("visitTime", timeText));
    if (workType === "DAY") {
      dispatch(setSchedule("hour", 24));
    }
  };

  const hourHandler = (event) => {
    let hourText = event.target.innerText;
    setHourName(hourText);
    let hourNum = Number(hourText.replace(/[^0-9]/g, ""));
    dispatch(setSchedule("hour", hourNum));
  };

  const timeTitle = "돌봄 시작 시간";
  const hourTitle = "하루 돌봄 시간";

  const test = new Date().getHours();

  const dateTests = `${new Date().getFullYear()}-${
    (new Date().getMonth() + 1).toString().length < 2
      ? "0" + (new Date().getMonth() + 1)
      : new Date().getMonth() + 1
  }-${new Date().getDate()}`;

  return (
    <div className={classes.screen}>
      <section className={classes.container}>
        <div className={classes.time}>
          <div>{timeTitle}</div>
          <button
            className={classes.button}
            onClick={modalHandler}
            value="time"
          >
            <div>{timeName}</div>
            <div>
              <img
                className={classes.buttonImg}
                src={buttonImg}
                alt=""
                value="time"
              />
            </div>
          </button>
        </div>
        <div className={classes.hour}>
          <div>{hourTitle}</div>
          <button
            className={classes.button}
            onClick={modalHandler}
            value="hour"
            disabled={workType === "DAY" ? true : false}
          >
            <div>{workType === "DAY" ? "24시간(변경불가)" : hourName}</div>
            <div>
              <img
                className={classes.buttonImg}
                src={buttonImg}
                alt=""
                value="hour"
              />
            </div>
          </button>
        </div>
      </section>
      {modal && (
        <ModalUI
          title={toggle === "time" ? timeTitle : hourTitle}
          onConfirm={onConfirm}
        >
          {(toggle === "time" ? timeTable : hourTable).map((data) => (
            <button
              onClick={toggle === "time" ? timeHandler : hourHandler}
              key={data.title}
              className={classes.option}
              disabled={
                toggle === "time" &&
                Number(data.title) - test <= 0 &&
                dateTests === startDate
              }
            >
              {data.text}
            </button>
          ))}
        </ModalUI>
      )}
    </div>
  );
};

export default WorkHours;
